import { NavLink, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

const NAV = [
  { to: '/guide/easy-start', label: 'Easy Start' },
  { to: '/features', label: 'Features' },
  { to: '/docs', label: 'Docs' },
  { to: '/versions', label: 'Versions' },
  { to: '/guide', label: 'User Guide' },
  { to: '/sdk', label: 'Plugin SDK' },
  { to: '/tools', label: 'Tools' },
  { to: '/roadmap', label: 'Roadmap' },
  { to: '/download', label: 'Download' },
  { to: '/sponsor', label: 'Sponsor' },
];

export function Header() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const close = () => setOpen(false);
    window.addEventListener('hashchange', close);
    return () => window.removeEventListener('hashchange', close);
  }, []);

  return (
    <header className="app-header">
      <div className="app-header__inner">
        <Link to="/" className="brand" onClick={() => setOpen(false)}>
          <img src="/images/logo-mark.svg" alt="" width={32} height={32} />
          <span className="brand__wordmark">DreamGraph</span>
        </Link>

        <button
          className="nav-toggle"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          <span /><span /><span />
        </button>

        <nav className={`primary-nav ${open ? 'primary-nav--open' : ''}`}>
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => (isActive ? 'is-active' : undefined)}
              onClick={() => setOpen(false)}
            >
              {item.label}
            </NavLink>
          ))}
          <a
            className="nav-cta"
            href="https://github.com/mmethodz/dreamgraph"
            target="_blank"
            rel="noreferrer"
          >
            GitHub →
          </a>
        </nav>
      </div>
    </header>
  );
}
